import React from 'react';

export const TreatmentLeftImage = ({ tr }) => {
  let imageUrl = ""; // Define a variable to hold the image URL
  if (tr === "HyperDry" || tr === "HyperDry Eco") {
    imageUrl = "/img/hyperdry/aside-two-tr.jpg";
  } else if (tr === "ExpeDRY") {
    imageUrl = "/img/expedry/treatment-expedry-two.jpg";
  } else if (tr === "UltraWht") {
    imageUrl = "/img/ultrawht/aside-two.jpg";
  } else if (tr === "ThermaDown O2+") {
    imageUrl = "/img/thermadown-o2-plus/aside-two.jpg";
  } else {
    imageUrl = "/img/hyperdry/aside-two-tr.jpg"; // Default case
  }

  return (<div className="il-add" data-beta-flow="true" style={{ backgroundImage: `url("${imageUrl}")`}}></div>);};
